const GET_UPCOMING_INVOICE = 'autohost/billing/GET_UPCOMING_INVOICE';
const GET_UPCOMING_INVOICE_SUCCESS = 'autohost/billing/GET_UPCOMING_INVOICE_SUCCESS';
const GET_UPCOMING_INVOICE_FAIL = 'autohost/billing/GET_UPCOMING_INVOICE_FAIL';


const initialState = {
    upcomingInvoice: null,
    error: null
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_UPCOMING_INVOICE_SUCCESS:
            return {
                ...state,
                upcomingInvoice: action.payload
            };
        case GET_UPCOMING_INVOICE_FAIL:
            return {
                ...state,
                error: action.error
            };
        default:
            return state;
    }
}

export function getUpcomingInvoice() {
    return {
        types: [GET_UPCOMING_INVOICE, GET_UPCOMING_INVOICE_SUCCESS, GET_UPCOMING_INVOICE_FAIL],
        promise: (client) => client.get(`/user/billing/upcomingInvoice`)
    };
}
